// @flow

import React from 'react'

// eslint does not recognize that these lines are being used
/* eslint-disable */
import { Route, Routes as Switch } from 'react-router-dom'
import { Content } from '../Components'
/* eslint-enable */
type RoutesProps = {
  data: {
    state: Object,
    url: string,
    host: string
  }
}
class Routes extends React.Component<RoutesProps, {}> {
  render () {
    return (
      <Switch>
        <Route path='/content/:id' element={<Content content={this.props.data.state} url={this.props.data.url} host={this.props.data.host} />} />
      </Switch>
    )
  }
}

export default Routes
